export enum ScreenSource {
  PLANNING_BOARD = "PLANNING BOARD",
  TO_BE_PLANNED_PLANNING_BOARD = "TO BE PLANNED PLANNING BOARD",
  WEEK_PLANNING_BOARD = "WEEK PLANNING BOARD",
  PLANNING_BLOCKS_SCREEN = "PLANNING BLOCKS SCREEN"
}
